import React, { Component } from 'react';
import Head from '../../../../components/Head/Head';
import Auxiliary from '../../../../hoc/Auxiliary/Auxiliary';
import { withTranslation } from 'react-i18next';
import OutsourcingAdvantagesBanner from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantagesBanner/OutsourcingAdvantagesBanner';
import OutsourcingAdvantagesIntro from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantagesIntro/OutsourcingAdvantagesIntro';
import OutsourcingAdvantages2 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages2/OutsourcingAdvantages2';
import OutsourcingAdvantages3 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages3/OutsourcingAdvantages3';
import OutsourcingAdvantages4 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages4/OutsourcingAdvantages4';
import OutsourcingAdvantages5 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages5/OutsourcingAdvantages5';
import OutsourcingAdvantages6 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages6/OutsourcingAdvantages6';
import OutsourcingAdvantages7 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages7/OutsourcingAdvantages7';
import OutsourcingAdvantages8 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages8/OutsourcingAdvantages8';
import OutsourcingAdvantages9 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingAdvantages/OutsourcingAdvantages9/OutsourcingAdvantages9';

class OutsourcingAdvantages extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-advantages" />
                <OutsourcingAdvantagesBanner {...this.props} />
                <OutsourcingAdvantagesIntro {...this.props} />
                <OutsourcingAdvantages2 {...this.props} />
                <OutsourcingAdvantages3 {...this.props} />
                <OutsourcingAdvantages4 {...this.props} />
                <OutsourcingAdvantages5 {...this.props} />
                <OutsourcingAdvantages6 {...this.props} />
                <OutsourcingAdvantages7 {...this.props} />
                <OutsourcingAdvantages8 {...this.props} />
                <OutsourcingAdvantages9 {...this.props} />
                <div className='custom-end-outsourcing-advantages'></div>
            </Auxiliary>
        );
    }
}

export default withTranslation()(OutsourcingAdvantages);
